@use 'sass:map';
@use 'sass:list';
@use '../../../global/style/nano-theme/form' as nanoForm;

// globals
@import '../../../global/style/utilities/globals';
@import '../../../global/style/nano-theme/base';
@import '../../../global/style/nano-theme/colours';
@import '../../../global/style/nano-theme/layers';

// local
@import 'setup';
@import 'bar';
@import 'burger';
@import 'search';
@import 'user';

:host {
  /**
   * @prop --bar-vertical-padding: Defaults to 21px;
   * @prop --bar-item-spacing: Defaults to 16px;
   * @prop --bar-background: Defaults to white;
   * @prop --bar-text-color: Defaults to #196c82;
   * @prop --bar-color-shade: Defaults to rgb(19 89 111);
   * @prop --bar-color-tint: Defaults to rgb(19 89 111);
   * @prop --bar-color-focus: Defaults to #001a21;
   * @prop --bar-user-panel-bg: Defaults to #016d86;

   * @prop --menu-background: Defaults to #001a21;
   * @prop --menu-text-color: Defaults to white;
   * @prop --bar-dropdown-bg: Defaults to #196c82;
   * @prop --bar-dropdown-text: Defaults to white;
   * @prop --menu-user-profile-bg: Defaults to #001a21;
   * @prop --menu-user-panel-bg: Defaults to #193037;
   * @prop --menu-padding: Defaults to 12px;
   * @prop --menu-hint-color: Defaults to #33484d;
   * @prop --menu-title-text: Defaults to #{map.get($colors, lightblue)};
   * @prop --menu-icon-color: Defaults to white;

   * @prop --login-button-bg: Defaults to #17bb75;
   * @prop --login-button-text: Defaults to white;
   */

  --bar-vertical-padding: 21px;
  --bar-item-spacing: 13px;
  --bar-background: white;
  --bar-text-color: #196c82;
  --bar-color-shade: rgb(12 90 113);
  --bar-color-tint: rgb(19 89 111);
  --bar-color-focus: #99a3a6;
  --bar-user-panel-bg: #016d86;
  --bar-dropdown-bg: #196c82;
  --bar-dropdown-text: white;
  --menu-background: #001a21;
  --menu-text-color: white;
  --menu-user-profile-bg: #001a21;
  --menu-user-panel-bg: #193037;
  --menu-padding: 12px;
  --menu-hint-color: #33484d;
  --menu-title-text: #{map.get($colors, lightblue)};
  --menu-icon-color: white;
  --login-button-bg: #17bb75;
  --login-button-text: white;

  // not sure if this required any more.
  --padding: 12px;
  --padding-top: var(--padding);
  --padding-end: var(--padding);
  --padding-bottom: var(--padding);
  --padding-start: var(--padding);

  display: flex;
  flex-direction: column;
  position: relative;
  line-height: 1.5;
  height: 100%;
  font-size: 0.9375em;
  font-size: clamp(0.77rem, 1vw, 0.9rem);

  input,
  select,
  button {
    font-family: inherit;
    appearance: none;
    font-size: inherit;
  }

  a,
  button {
    &:focus {
      outline: none;
    }

    &:focus-visible {
      box-shadow: #{nanoForm.$control-focus-style};
    }
  }
}
